import styled from 'styled-components'

export default styled.button<{isOther?: boolean}>`
  // reset button styles
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  font-size: 1.8rem;
  @media screen and (max-width: 768px) {
    font-size: 1.4rem;
  }
  border: none;
  outline: 2px solid;
  outline-color: transparent;
  cursor: pointer;
  transition-property: box-shadow, opacity, outline-color, font-size;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
  font-family: var(--font-plex);
  font-weight: 500;
  line-height: 1.1;
  padding: .4em .6em;
  background: ${({isOther})=> isOther ? "var(--other-button-background)": "var(--button-background)" } ;
  color: white;
  border-radius: .3em;

  &:hover {
    outline-color: var(--yellow-main);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    outline-color: transparent;
  }
  &.selected {
    outline-color: var(--yellow-main);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    color: var(--yellow-main);
    /* font-weight: 550;
    letter-spacing: -.9px; */
    /* text-shadow: .25px 0px .1px,
                  -.25px 0px .1px; */
    /* padding: 7px 8px; */
    animation: bounceOnce 0.3s ease-in-out;
    @keyframes bounceOnce {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.03);
      }
      100% {
        transform: scale(1);
      }
    }
  }
`
